/* eslint-disable import/prefer-default-export */
import { fetch } from 'server/api'
import _ from 'lodash'

export const getCardByUid = (cardUid, params = {}) => {
  let paramsUrl = ''

  const headersToForward = { 'X-Record-Visit': false }

  _.forEach(params, (value, key) => {
    paramsUrl += `&${key}=${value}`
  })

  return fetch(`cards/uid/${cardUid}?${encodeURI(paramsUrl)}`, headersToForward)
}
